(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 79102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MaxWidthContainer; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40639);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaxWidthContainer = function MaxWidthContainer(_ref) {
  var children = _ref.children,
      rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, _objectSpread(_objectSpread({
    maxW: "5xl",
    w: "100%"
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Home": function() { return /* binding */ Home; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(8395);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./components/ConditionalScroll/index.tsx
var ConditionalScroll = __webpack_require__(35792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ActionButton/index.tsx


var _excluded = ["bg", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function ActionButton(props) {
  var bg = props.bg,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var background = bg || 'primary';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ConditionalScroll/* ConditionalScrollButton */.OW, _objectSpread(_objectSpread({
    bg: background,
    color: 'whiteAlpha.900',
    px: 6,
    boxShadow: "lg",
    _hover: {
      bg: background === 'primary' ? 'accent' : 'primary'
    }
  }, rest), {}, {
    children: children
  }));
}
// EXTERNAL MODULE: ./components/MaxWidthContainer/index.tsx
var MaxWidthContainer = __webpack_require__(79102);
;// CONCATENATED MODULE: ./components/HomeSection/index.tsx


var HomeSection_excluded = ["children", "shaded", "id"];

function HomeSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HomeSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HomeSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HomeSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HomeSection = function HomeSection(_ref) {
  var children = _ref.children,
      _ref$shaded = _ref.shaded,
      shaded = _ref$shaded === void 0 ? false : _ref$shaded,
      id = _ref.id,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, HomeSection_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, HomeSection_objectSpread(HomeSection_objectSpread({
    id: id,
    bg: shaded ? 'lightBeige' : 'transparent',
    py: {
      base: 50,
      md: 75
    }
  }, rest), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaxWidthContainer/* MaxWidthContainer */.a, {
      children: children
    })
  }));
};
// EXTERNAL MODULE: ./svgs/EBLogo/index.tsx
var EBLogo = __webpack_require__(93142);
;// CONCATENATED MODULE: ./components/Hero/index.tsx









var Arrow = (0,index_esm/* createIcon */.IU)({
  displayName: 'Arrow',
  viewBox: '0 0 72 24',
  path: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600904 7.08166C0.764293 6.8879 1.01492 6.79004 1.26654 6.82177C2.83216 7.01918 5.20326 7.24581 7.54543 7.23964C9.92491 7.23338 12.1351 6.98464 13.4704 6.32142C13.84 6.13785 14.2885 6.28805 14.4722 6.65692C14.6559 7.02578 14.5052 7.47362 14.1356 7.6572C12.4625 8.48822 9.94063 8.72541 7.54852 8.7317C5.67514 8.73663 3.79547 8.5985 2.29921 8.44247C2.80955 9.59638 3.50943 10.6396 4.24665 11.7384C4.39435 11.9585 4.54354 12.1809 4.69301 12.4068C5.79543 14.0733 6.88128 15.8995 7.1179 18.2636C7.15893 18.6735 6.85928 19.0393 6.4486 19.0805C6.03792 19.1217 5.67174 18.8227 5.6307 18.4128C5.43271 16.4346 4.52957 14.868 3.4457 13.2296C3.3058 13.0181 3.16221 12.8046 3.01684 12.5885C2.05899 11.1646 1.02372 9.62564 0.457909 7.78069C0.383671 7.53862 0.437515 7.27541 0.600904 7.08166ZM5.52039 10.2248C5.77662 9.90161 6.24663 9.84687 6.57018 10.1025C16.4834 17.9344 29.9158 22.4064 42.0781 21.4773C54.1988 20.5514 65.0339 14.2748 69.9746 0.584299C70.1145 0.196597 70.5427 -0.0046455 70.931 0.134813C71.3193 0.274276 71.5206 0.70162 71.3807 1.08932C66.2105 15.4159 54.8056 22.0014 42.1913 22.965C29.6185 23.9254 15.8207 19.3142 5.64226 11.2727C5.31871 11.0171 5.26415 10.5479 5.52039 10.2248Z",
    fill: "currentColor"
  })
});
var Hero = function Hero() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(HomeSection, {
      id: 'section-hero',
      py: 0,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        direction: {
          base: 'column',
          md: 'row'
        },
        align: "center",
        py: {
          base: 0,
          md: 10
        },
        id: "section-hero",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
          w: {
            base: '100%',
            md: '50%'
          },
          px: {
            base: 10,
            md: 0
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: '/book-cover-3d.jpg',
            layout: "responsive",
            width: 812,
            height: 988,
            alt: "Cut Into The Jamstack book cover",
            priority: true
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
            direction: "column",
            align: "center",
            justify: "flex-start",
            mb: 10,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
              direction: "row",
              align: "center",
              justify: "space-between",
              h: 30,
              mb: 2,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mr: 2,
                children: "by"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontWeight: "bold",
                fontSize: 18,
                children: "Mike Cavaliere"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
              direction: "row",
              align: "center",
              justify: "space-between",
              h: 30,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mr: 2,
                children: "of"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(EBLogo/* EBLogo */.Z, {
                width: 130
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
          as: dist_index_esm/* Box */.xu,
          textAlign: 'center',
          w: {
            xs: '100%',
            md: '50%'
          },
          mb: 10,
          spacing: {
            base: 5
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
            fontWeight: 600,
            fontSize: {
              base: '3xl',
              sm: '4xl',
              md: '5xl'
            },
            lineHeight: '120%',
            children: ["Build a SaaS with ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
              as: 'span',
              color: 'teal',
              children: "React and Next.js"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
            mb: 10,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
              as: 'span',
              fontSize: 17,
              children: "Learn how to build full-stack Jamstack apps by building one from scratch."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
            direction: 'column',
            spacing: 4,
            align: 'center',
            alignSelf: 'center',
            position: 'relative',
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ActionButton, {
              rounded: "full",
              size: "lg",
              href: "/#section-pricing",
              children: "Buy Now"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ConditionalScroll/* ConditionalScrollButton */.OW, {
              href: "/#section-summary",
              variant: 'link',
              colorScheme: 'blue',
              size: 'sm',
              children: "Learn more"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Icon */.JO, {
                as: Arrow,
                color: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.800', 'gray.300'),
                w: 71,
                position: 'absolute',
                right: -71,
                top: '10px'
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: 'lg',
                fontFamily: 'Caveat',
                position: 'absolute',
                right: '-125px',
                top: '-15px',
                transform: 'rotate(10deg)',
                children: "Early release discount!"
              })]
            })]
          })]
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./node_modules/react-icons/fc/index.esm.js
var fc_index_esm = __webpack_require__(81872);
;// CONCATENATED MODULE: ./components/Features/index.tsx






var Feature = function Feature(_ref) {
  var title = _ref.title,
      text = _ref.text,
      icon = _ref.icon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
    align: 'center',
    bg: 'white',
    boxShadow: 'base',
    py: 6,
    px: 4,
    rounded: "lg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
      w: 16,
      h: 16,
      align: 'center',
      justify: 'center',
      color: 'white',
      rounded: 'full',
      bg: 'white',
      mb: 2,
      borderWidth: 1,
      borderColor: 'lightBeige',
      children: icon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
      fontSize: 21,
      fontWeight: 600,
      color: 'accent',
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
      fontSize: 15,
      color: 'gray.600',
      children: text
    })]
  });
};

function Features() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomeSection, {
    id: 'section-features',
    shaded: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      py: 4,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
        columns: {
          base: 1,
          md: 3
        },
        spacing: 7,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Feature, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Icon */.JO, {
            as: fc_index_esm/* FcGraduationCap */.zsC,
            w: 10,
            h: 10
          }),
          title: 'Learn the Jamstack',
          text: 'The Jamstack (JavaScript, API and markup) produces FAST powerful websites that are fun to build.'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Feature, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Icon */.JO, {
            as: fc_index_esm/* FcSupport */._CL,
            w: 10,
            h: 10
          }),
          title: 'Learn by Doing',
          text: 'The book teaches you how I built JamShots, a collaborative photo gallery application, step-by-step with every line of code broken down.'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Feature, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Icon */.JO, {
            as: fc_index_esm/* FcStackOfPhotos */._vR,
            w: 10,
            h: 10
          }),
          title: 'Full-Stack JavaScript',
          text: "You'll build JamShots with some of the hottest JavaScript frameworks and libraries around. "
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 4 modules
var toast_dist_index_esm = __webpack_require__(20310);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__(83234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/NewsletterSignup/index.tsx



function NewsletterSignup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NewsletterSignup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NewsletterSignup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NewsletterSignup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









function subscribe(_x) {
  return _subscribe.apply(this, arguments);
}

function _subscribe() {
  _subscribe = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(email) {
    var body, headers, response, json;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            body = JSON.stringify({
              email: email
            });
            headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            };
            _context2.next = 4;
            return fetch('/api/subscribe', {
              headers: headers,
              method: 'POST',
              body: body
            });

          case 4:
            response = _context2.sent;
            json = response.json();

            if (response.ok) {
              _context2.next = 8;
              break;
            }

            throw json;

          case 8:
            return _context2.abrupt("return", json);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _subscribe.apply(this, arguments);
}

function NewsletterSignup() {
  var _useForm = (0,react_hook_form_dist_index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var _useState = (0,react.useState)(false),
      isSubmitting = _useState[0],
      setIsSubmitting = _useState[1];

  var toast = (0,toast_dist_index_esm/* useToast */.pm)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsSubmitting(true);
              _context.next = 4;
              return subscribe(data.email);

            case 4:
              toast({
                title: 'Subscribed!',
                description: 'Check your inbox for a confirmation message.',
                status: 'success',
                duration: 9000,
                isClosable: true
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              toast({
                title: 'Oops',
                description: 'There was an error, sorry about that. Try again.',
                status: 'error',
                duration: 9000,
                isClosable: true
              });

            case 10:
              _context.prev = 10;
              setIsSubmitting(false);
              return _context.finish(10);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7, 10, 13]]);
    }));

    return function onSubmit(_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomeSection, {
    id: 'section-newsletter',
    shaded: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
      align: 'center',
      justify: 'center',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
        rounded: 'xl',
        p: 10,
        spacing: 8,
        align: 'center',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Icon */.JO, {
          as: NotificationIcon,
          w: 24,
          h: 24
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          onSubmit: handleSubmit(onSubmit),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
            align: 'center',
            spacing: 2,
            mb: 5,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
              textTransform: 'uppercase',
              fontSize: '3xl',
              color: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.800', 'gray.200'),
              children: "Free stuff!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
              fontSize: 'lg',
              color: 'gray.500',
              children: "Signup for Jamstack lessons, blog posts, book news, bonuses."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control_dist_index_esm/* FormControl */.NI, {
            isInvalid: !!(errors !== null && errors !== void 0 && errors.email),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
              spacing: 4,
              direction: {
                base: 'column',
                md: 'row'
              },
              w: 'full',
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, NewsletterSignup_objectSpread({
                type: "email",
                name: "email",
                placeholder: 'superdev@icodejamstackapps.net',
                color: "gray.800",
                bg: "white",
                rounded: 'full',
                border: 0,
                _focus: {
                  bg: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.200', 'gray.800'),
                  outline: 'none'
                }
              }, register('email', {
                required: true
              }))), /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                color: 'whiteAlpha.900',
                px: 6,
                boxShadow: "lg",
                _hover: {
                  bg: 'primary'
                } // @ts-ignore
                ,
                href: "/#section-newsletter",
                bg: 'accent',
                rounded: 'full',
                flex: '1 0 auto',
                isLoading: isSubmitting,
                type: "submit",
                children: "Subscribe"
              })]
            }), errors.email && /*#__PURE__*/(0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormErrorMessage */.J1, {
              flexDirection: "row",
              justifyContent: {
                base: 'center',
                md: 'flex-start'
              },
              display: "flex",
              children: "Email is required."
            })]
          })]
        })]
      })
    })
  });
}
var NotificationIcon = (0,index_esm/* createIcon */.IU)({
  displayName: 'Notification',
  viewBox: '0 0 128 128',
  path: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
    id: "Notification",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      className: "cls-1",
      x: "1",
      y: "45",
      fill: '#fbcc88',
      width: "108",
      height: "82"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      className: "cls-2",
      fill: '#8cdd79',
      cx: "105",
      cy: "86",
      r: "22"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      className: "cls-3",
      fill: '#f6b756',
      x: "1",
      y: "122",
      width: "108",
      height: "5"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-4",
      fill: '#7ece67',
      d: "M105,108A22,22,0,0,1,83.09,84a22,22,0,0,0,43.82,0A22,22,0,0,1,105,108Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: '#f6b756',
      className: "cls-3",
      d: "M109,107.63v4A22,22,0,0,1,83.09,88,22,22,0,0,0,109,107.63Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-5",
      fill: '#d6ac90',
      d: "M93,30l16,15L65.91,84.9a16,16,0,0,1-21.82,0L1,45,17,30Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-6",
      fill: '#cba07a',
      d: "M109,45,65.91,84.9a16,16,0,0,1-21.82,0L1,45l2.68-2.52c43.4,40.19,41.54,39.08,45.46,40.6A16,16,0,0,0,65.91,79.9l40.41-37.42Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-7",
      fill: '#dde1e8',
      d: "M93,1V59.82L65.91,84.9a16,16,0,0,1-16.77,3.18C45.42,86.64,47,87.6,17,59.82V1Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-8",
      fill: '#c7cdd8',
      d: "M74,56c-3.56-5.94-3-10.65-3-17.55a16.43,16.43,0,0,0-12.34-16,5,5,0,1,0-7.32,0A16,16,0,0,0,39,38c0,7.13.59,12-3,18a3,3,0,0,0,0,6H50.41a5,5,0,1,0,9.18,0H74a3,3,0,0,0,0-6ZM53.2,21.37a3,3,0,1,1,3.6,0,1,1,0,0,0-.42.7,11.48,11.48,0,0,0-2.77,0A1,1,0,0,0,53.2,21.37Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-3",
      fill: '#f6b756',
      d: "M46.09,86.73,3,127H1v-1c6-5.62-1.26,1.17,43.7-40.78A1,1,0,0,1,46.09,86.73Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-3",
      fill: '#f6b756',
      d: "M109,126v1h-2L63.91,86.73a1,1,0,0,1,1.39-1.49C111,127.85,103.11,120.51,109,126Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-8",
      fill: '#c7cdd8',
      d: "M93,54.81v5L65.91,84.9a16,16,0,0,1-16.77,3.18C45.42,86.64,47,87.6,17,59.82v-5L44.09,79.9a16,16,0,0,0,21.82,0Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-9",
      fill: '#fff',
      d: "M101,95c-.59,0-.08.34-8.72-8.3a1,1,0,0,1,1.44-1.44L101,92.56l15.28-15.28a1,1,0,0,1,1.44,1.44C100.21,96.23,101.6,95,101,95Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-3",
      fill: '#f6b756',
      d: "M56.8,18.38a3,3,0,1,0-3.6,0A1,1,0,0,1,52,20,5,5,0,1,1,58,20,1,1,0,0,1,56.8,18.38Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-1",
      fill: '#fbcc88',
      d: "M71,42.17V35.45c0-8.61-6.62-16-15.23-16.43A16,16,0,0,0,39,35c0,7.33.58,12-3,18H74A21.06,21.06,0,0,1,71,42.17Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-3",
      fill: '#f6b756',
      d: "M74,53H36a21.36,21.36,0,0,0,1.86-4H72.14A21.36,21.36,0,0,0,74,53Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-3",
      fill: '#f6b756',
      d: "M59.59,59a5,5,0,1,1-9.18,0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "cls-1",
      fill: '#fbcc88',
      d: "M74,59H36a3,3,0,0,1,0-6H74a3,3,0,0,1,0,6Z"
    })]
  })
});
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
;// CONCATENATED MODULE: ./components/Pricing/index.tsx








function PriceWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
    mt: 4,
    shadow: "base",
    borderWidth: "1px",
    alignSelf: {
      base: 'center',
      lg: 'flex-start'
    },
    borderColor: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)('gray.200', 'gray.500'),
    borderRadius: 'xl',
    bg: 'white',
    children: children
  });
}

function Pricing() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HomeSection, {
    id: 'section-pricing',
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* VStack */.gC, {
      spacing: 2,
      textAlign: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
        as: "h1",
        fontSize: "4xl",
        children: "Get the Early Release"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontSize: "lg",
        color: 'gray.500',
        children: "Over 170 pages of lessons and examples for an incredible price. Free updates as the book grows."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
      direction: {
        base: 'column',
        md: 'row'
      },
      textAlign: "center",
      justify: "center",
      spacing: {
        base: 4,
        lg: 10
      },
      pt: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PriceWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
          position: "relative",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
            position: "absolute",
            top: "-16px",
            left: "50%",
            style: {
              transform: 'translate(-50%)'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
              textTransform: "uppercase",
              bg: '#f0d8b4',
              px: 3,
              py: 1,
              color: 'accent',
              fontSize: "sm",
              fontWeight: "600",
              rounded: "xl",
              children: "Beta book"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
            pt: 10,
            pb: 6,
            px: 12,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
              fontWeight: "500",
              fontSize: "2xl",
              children: "Current release"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
              justifyContent: "center",
              marginLeft: "-50px",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: "xl",
                color: "gray.400",
                textDecoration: "line-through",
                children: "$30"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                fontSize: "3xl",
                fontWeight: "bold",
                children: "$10"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* VStack */.gC, {
            borderTopWidth: 1,
            borderTopColor: 'lightBeige',
            py: 4,
            borderBottomRadius: 'xl',
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* List */.aV, {
              pt: 2,
              spacing: 3,
              textAlign: "start",
              px: 12,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ListIcon */.DE, {
                  as: fa_index_esm/* FaCheckCircle */.FJM,
                  color: "green.500"
                }), "Over 170 pages of content"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ListIcon */.DE, {
                  as: fa_index_esm/* FaCheckCircle */.FJM,
                  color: "green.500"
                }), "Full source code"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ListIcon */.DE, {
                  as: fa_index_esm/* FaCheckCircle */.FJM,
                  color: "green.500"
                }), "Free updates"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ListIcon */.DE, {
                  as: fa_index_esm/* FaCheckCircle */.FJM,
                  color: "green.500"
                }), "Dozens of lessons"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ListIcon */.DE, {
                  as: fa_index_esm/* FaCheckCircle */.FJM,
                  color: "green.500"
                }), "Free access to JamShots photo app when it's live"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
              w: "80%",
              pt: 7,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActionButton, {
                w: "full",
                href: constants/* PRODUCT_PAGE_URL */.nm,
                target: "_blank",
                children: "Buy Now"
              })
            })]
          })]
        })
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js
var avatar_dist_index_esm = __webpack_require__(3812);
;// CONCATENATED MODULE: ./components/Summary/index.tsx




function Summary() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomeSection, {
    id: 'about',
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
      py: 16,
      px: 8,
      spacing: {
        base: 8,
        md: 10
      },
      align: 'center',
      direction: 'column',
      id: "section-summary",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        textAlign: 'center',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
          size: "xl",
          children: "Why a Jamstack SaaS book?"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        fontSize: {
          base: 'xl',
          md: '2xl'
        },
        textAlign: 'center',
        maxW: '3xl',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: ["Hey, I'm", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
            href: "https://mikecavaliere.com/",
            target: "_blank",
            fontWeight: "bold",
            textDecoration: "underline",
            children: "Mike Cavaliere"
          }), ". I'm a Senior Software Engineer for an agency called", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
            href: "https://echobind.com/",
            target: "_blank",
            fontWeight: "bold",
            textDecoration: "underline",
            children: "Echobind"
          }), ". I've been writing code for two decades, and have been using JavaScript the whole time."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: "I absolutely love the Jamstack (JavaScript, APIs and markup) way of building things. But JavaScript evolves fast, and there are a ton of tools to choose from."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: "What form library should I use? How should I style things? Where do I put all my data? It's kind of overwhelming. \uD83E\uDD2F"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: "When you're building a SaaS (software-as-a-service) app, there are new challenges."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: "Do I need a database? Where should I host it? How do I keep my DB in sync with API data? Double \uD83E\uDD2F\uD83E\uDD2F"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: ["In ", /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            children: "Cut Into The Jamstack"
          }), ", I answer all of these questions and more. I'll walk you through how I'm building a SaaS app, line by line with complete source code."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: "You'll get a taste of all of the popular libraries below and see how they work together to build a working, usable app."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
          mb: 5,
          children: ["After reading ", /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            children: "Cut Into The Jamstack"
          }), ", you'll feel much more comfortable kicking off your own Jamstack SaaS projects with all of these tools. I look forward to having you read it!"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        textAlign: 'center',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
          src: '/mike.jpg',
          mb: 2,
          size: "2xl",
          name: "Photo of Mike Cavaliere, Senior Software Engineer and author of Cut Into the Jamstack",
          width: 128,
          height: 128
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontWeight: 600,
          children: "Mike Cavaliere"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontSize: 'sm',
          children: "Senior Software Engineer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
          fontSize: 'sm',
          children: "Echobind"
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ./svgs/NextAuthLogo/index.tsx


var NextAuthLogo = function NextAuthLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 229 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 54 : _ref$height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: width,
    height: height,
    viewBox: "0 0 80.692882 19.049998",
    version: "1.1",
    id: "svg5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      id: "defs2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "layer1",
      transform: "translate(-37.54845,-84.347511)",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        id: "g12",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("text", {
          xmlSpace: "preserve",
          style: {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '10.5833px',
            lineHeight: '1.25',
            fontFamily: 'sans-serif',
            fill: '#000000',
            fillOpacity: 1,
            stroke: 'none',
            strokeWidth: '0.264583'
          },
          x: "59.557762",
          y: "97.027893",
          id: "text143",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("tspan", {
            id: "tspan141" // style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-family:'Segoe UI';-inkscape-font-specification:'Segoe UI';stroke-width:0.264583"
            ,
            style: {
              fontStyle: 'normal',
              fontVariant: 'normal',
              fontWeight: 'bold',
              fontStretch: 'normal',
              fontFamily: "'Segoe UI'",
              strokeWidth: '0.264583'
            },
            x: "59.557762",
            y: "97.027893",
            children: "NextAuth.js"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("image", {
          width: "17.197916",
          height: "19.049999",
          preserveAspectRatio: "none" // style="image-rendering:optimizeSpeed"
          ,
          xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABICAYAAACp+JiNAAAABHNCSVQICAgIfAhkiAAAFSlJREFU eJzFWnuwVVd5/31r73PuuZd3eBODoIE0RAlBiDpajQRjHo3GGh+JtU7tjFo709ZJx6l10rHWmY7W aZy2o1ObaDSTgDGJRJKgyCNQCASQN4RwuRAel9flvu85956z91pf/1jPvc+5QIDQzWzOfpxz9vr9 vt/3+761ziX8P2wTZsy+YfaiT39u4h0PfjEqjZlQ6znbeW7tsz9vfflXSzuPHjxwtcdDV+tBMxfe tuidH/vsF+L5ty0+NXbK1C7RFBEicHUIpAiQjHEyVZN6O06lu9etalu99BfHdqxdczXG9paR0Dx6 3DWzFt3zyWsX3/9AZdbNC06WRo4eLDQTKQInKUgywASu1gDFIBBABVBUADFQqiU8eajS33R4x9aT 655e0rbpN88N9Xd3vxVjvaIkjJ85e87su+9/YMwf33nfuWlvn31SxEUqtgApA4kEFAAmEAvzakhg dtfApAlBBIpiEAGoKUxMk+qY022Here8sOzQ+l8+1X3swP4rNe7LI0EIMeN9H1o84577vyAWvG/R qdHjpvQUmgSooEGnSkudBYj1a3hMIHC1CiiYa/66JQQgEAQgBCgCIIFRiVLje86eru19ec2xdU89 cWLX2lVgpa4aCc3jrplw/Ufv+tTkO+/9XHn2H73nRHNpVK1QAikC1yRIIoi2yEVe5AghwKRDHjwx ARDBsSUFABEo1pfiGjCx3N9fOLzzD2c2Pr3kjS3Lnqn2dXVdURIIoGtmzZ7zznvufXDUokWf6Hjb tFkno6gois1AovSuAFIiiHRj0F7yARFGCQBlyKlTQ3CsCQkGGAOIAK4B19RqtZEn2g72blv+/NGN v3yy98SB1y6JhKhYbJrxwQ/eMeMT9z7IC+Z9+PiYEZO7CwUBioGaAlIFKDEMSPOqjIxVAB5CkwVy r1ytaZOEIQ2UJQrUQA0BCfmICQAxAAaah6Qa23n2dG3PujUnNy594tS+tWsg03RYEkZNmXztDffc 9Zkpdy++v3LDjLknStHIoWIRMgXSWgqZMliJerAsnAqyeZ+PfFYd9pirVZ1CFiwCg8yQYAny7wWh MRkWmVWJAKIqMLavv18c2vmHc6/8amn79mXP1Po6OwGAZr7/1o/M/963ftx13YR3dMRckHERSU1C JhJSAVIJSEWQLKBUMCDVgAyjgHqihvcIrtZAir1SnOwDPwhTYjg15AlpcG7TBgkwspLUSscOHjz0 2N/8VXT/sl9seu3G8TPKKo2UVFCpBEsGg8BMYBCUeSDbKMCWMbjcpcz18K4fMFFwj0mXPyl1iXSi pODYSJUo91wK7w6/5W8rAKkmJx0ZRcm4SZMW1CbNjAstLSNRq4Kk9I8ghn+s2Unv7Nhg/xSy5/l7 wXWi7D1iMIej9NdhSLIvxOxBua/OIWyUGsP4hmgCpnQk+JM9Q+jqSKOYWen4mhQjE5WQDCEAljqS ihlEDKMVA4xg/2fS1xmsmyHzPfZ9sPfCUZO5YsHae2T6h+G2EDg3uJbfIm2c89oG8ZF9FZSSCGeT NI3JBAkw0ScjU3NsxqJrM9hc8xG2oD1IwEffqsNEPgPe0GaIDpXF7jnm2IGjegLzmh+GACoCpSHG 7fv6MfdIDZIBxQyZMsf6axgkAFJ63EQMYcYuyEdZK4TBFADhMJrsNKEBwKsiQ1COrEz6WNcPSHFZ EqQVDVMm69Ab+Z9Lcef2fkzukpCKoZT+uJLMsWJ2LQjARgVGDWylrFNCKW1NyoDSUoeTvlMHdMo0 9AYDhsl8xj08mxIMMt9ho+tLYqiZ85FBEQABzG0dxO27yyhWNXi92+8WiGsyVYIEFGkJEjOEZZ+y fkwASDBIIVBBKH1y170qvB6sijTmIF0CVZi2Sd8L/ECT5qPriMkYtP86KgJNVYXbd5Ux73AVSjGk JYA1GREEjnXu3ioGd7fugBBBFdCMEwHC+QS7HSE4CoEEgDLRDYEi8z4OX7Uru8/5+7kwU4PjXKaJ EjC5M8HnX+7FvENDUClDpoCSrPcUkCkgJaO96/W9ou/IsYMEZaKuHyrsd5uBUXBudwveAmBDCIeE OGDh7t8bXsuShPrvyBHCDT5DEUAF4N2tFfzZ2l5M6Ug14AC8JoChUkaSSFRq3Z1x+dTZE0ilB2kD GZRK6weCGSrwCy+/YOA2kvleAjnjrLtnXIYIbJunhgbZQBlMXv7bBjD/YBWKveztbg3Rn1dVudrd Gfcebz/SrJSPssVC5KqEssMw1yxma4CujHEAKKgWddUh3zNkwHIAHgE5QfhzBklNhEkdNXx8ywCm dEgHXgYmqHLHrASq6WC5nHR1xD0n2o+Mk4IrMTs/IgACgCLSZMAYovTpIIggcxF3PYMdXmicofGF PYN1O9ucZPoN+PscEqSZoEiAIsLc1gru2FZGaSgbaQ7Ay9wxmFCp9vUMJr3dcefxY21zaiwHmygm pXQKZJongMzcQJulniORlWbgDZQHHQDT7p5NgWErgyuhGizX/Q9QIUahJvHRrWUsfE27P+eiLYch QLF+zsBQV2dVVgbige6us6VBVaUxcWxZJ/jSqCsFG4WQu68NkzQhFnyYAhykgq3lGYML+goK4Vle MqYDZ0RMoKYiJp+r4uMbB3DtGWmiPrz03TEbhTAACPRWz7QzKxUzMxe7B/to2ugRWvYm8sqaI5wK bI+QKaccRtxjqCudocE5rwjSwXkEoc48rUeICCSKmHtwAHdvGkRp0OQ3M5T0aaDCc2Yw16dIBKB7 8PgRQK/BgNq72+ndY6aSG5MeiiDo7tB6BVNGBTA+4SMaqsDBzBlo3i8sLcEcwpDLFEyq4hIKicSd m3vw/r0JpESGALaAVUgGMkpgowJlAtk1dPSQI6FyuL0VPH2BNR7rBXadwDVMgkDKd5b2fSrvB+HE KVcKs35hiHOlhVwmhBWDmlow+ewQPrm+gumnuA6YypW+fGlUyqvBzxtSdFePtenEANC1/+AuJNJX AtY56jtF6xFmah2W01D++RTIN0UwjRJsUxUSg9w562X2pibc/PoAvvJ8GW9vZ3AKqJTBqT9WUjdB LFkTInV3yK5LNK+paZgkoZpUkt7ayTecEk7t3fvq9BpjsKAjbh3RVy9PhL7Dpmcwaw1KL5DYUu7i H8wh3KTKTQktUci9R5soFYuIq4y71/Xjg7skWJJzdlZ2Z5/n7FOApVeATZEwTcCEctp9ri851e5I ONn6+q45FSRD11ABCt4DSM8f2CyFEbMB7VUB2D4mNMBciUT+nm+UXO233sAM0dyMiWdr+MyaGmYe JyhFmmgHxstbn+suU2WIsYBtGvj0IUTorZ48VpX9Pd4T+vu6WzqqfTSxZTylqfGCkIygSpjBupkm bEeR84MAtFsGMaWwfn3BvIoIIm7CvP0VfGqtwsgBcoPXkdYAYSOeAex9gDnrFxyQpBgQiHBuqG0/ m2IZu5Ru6zgs3jVzvGQtfdegBatLbm4hCCQtLYAQvlT5QpdfdarvD/wXM1AooFhj3LNmELdtAyg0 MRNhDgC6mh+CdxUhqwprlAybuoyztdd2Wex2woiebfs2swzMkeBcW1BIAnvTFOwVb/OibmqdNcfM 9NmqotSMiV0pvvaMxOItAKXQZU9qs2Nrbsofs9mV9O8N70NqA7T+wIqdSSZplc9WX9tZR8KRjRtf KA5K3SwFbbOwgicL3lQHV/MZgryk/dQa/jUAnZk+CwEqNWH+/iE89BQw+w3y4FwV8CBgAStbFdhV Bb0HhEg2hsmeCAlARign5zq7ksPu5zmXDkf27Nh4Uzeqp6eKJiitCGY9WAHS/baZQeriQXoeIaAn Vma66cA2XHWCv16IEdcYH/+9xMc2xnqgQS7DSJ9zuR8aZHgv7AfYrh+GnzHvBQt01o68XlFdHXUk VIcGy80He46L6yZcrxKZMUaY0mW7SM4QQrALL1boFrjrEJ1BmhJYKmHyaYm/fD7G9a0EKZXzFFfK OFsJkPMFb3rIksIIKgfnTBIQiHE62bkJboU4SAcA6N+0Zx3c2oIG4nsENmTovBemT3ANlPOEoFza vLcpIAhUasKCPQke/mkRN7UWchImD8hKXNn7Wtb63MtfX+MsIZKBMD2CqiFVgvbatvUh7gwJrStX P10qs7vqPY8dMb5csjPPzLKbLXl5kyzEKAD47EuMh55owfiuyAzYAFRmD/Pb5TFnjM+Dz84J7OfD auGeoXTuVtLO3jPpvu0h7jg8ad29Ze3NJ1W5MisaASkzq02Z5TY3XwjnGa7RRNgUMQGiVMLkUxJf /vUI3HygGUoxZDBoO1hwzg9kkOOclb7rHFFfQrOv3g+IY3SkB3aUVcfJYUlIZJIUt57YLW6Y8X4V LKPpqbRdKg8CbdUBuOU4Yr3CZPOfCk1YsEvhK8+OxfiuCNLlOLsoIRx0xshygIImyeY+gvfkzTRj qgwIFjhW2/j70A/q0gEAjixb8XhhULlcsKUR8LNGYXxCWPAgrxoRuD8TPr88xjd/NhYTOiMDuF7S WQ8IyLEEObWw/rwlJegBwi4SGcMkIxdCjcvp0XTDb/OY60j4w/oVS6aewJAoRLA/vSHjB1r3Wvqc uU5WIc1NmNzFePjR0fjc78YgqgkPWhIgkSPEmh5lzMz6BFSesOx9F/l8tVBezQIxOlXr/k7ZuueC JJQHB/pLm07sIiFg9e/kDjQG7TpIAjU3YeEewr/9cBIW7h2poymDQTrAWTXYiMOSEygiU/6GSxn7 HTY13KZPIirgjeTlFxSS5IIkAMDBZ37zk1JZ6ZIWKgB+EqVb5qCEFiIUiPD55SX8839PxeSOYkbm XtpeviF4lwrsryMDMPgMZz8PG3F2WZzZCDoV2pI1yxrhbUjC1g0vLbnuEA+IYmS+xHyZKXt+kcUQ UmrCxB7CPz06EV98cQLiGuloSD9YdilQ7wHW0DINkfSA2e5hlTDvd3r3iBuALOCs3LOjQ+7fcdEk DCVDg+rFPSuF8s2RmzgBLi2EAERzEe/ZK/D9/3gbbt072hiRzU1ywD1ANumBBlWBgutsCMjluCUg 6MTzG7lb2rwERXi99tISBVn3l2vDkgAAG5587LuTzgiFWGRmle5H2ThCRIRP/3YEHn5sOqZ0lDRY BpiFXnMMmyAVpERgYE7WThVsCAhSgTmT51nsNNwNEBgCEQbk6e6Dye9+NRzWYUloO7Zvx+RVHfui QlT3SFEqYkIv4ZuPT8WfvzgNhZrI1mflJQwFF/m8ifm8ZhfdjCfYiCOMrjmvA9xoI8RoQmu66rkB debEmyYBAHb8z0+/M6aTQbEw7g9QcxE3HyjgX340A7fuHWciFXTIppOENPW5DjT7Y/Z136dAfhQN dG97mJAl+Bm6v0Co8UCyu/r0T86H87wkbN658rmZ6ytHqRiB4ghCEO5bOQrfemwmpp5rDmbLZh2B Yf6g2wxMkcvl0ATBngxHUAgmg8P+GJPjpe6d9acxingj3bTmdLp36/lwRue7CYBHnap2j7h34X1N NcLXllyLuzdMBaXC5HBgaG6G51d1WaqsAXLQ85vjlKVOncwyTX7PxxzDnvvrBIZSK8vf/usedbzt fCDPqwQAWLtl2RO3LOnc991Hb8T79k7I5mn2qU4BeubMAJPv8W2uczjMYNJVnwfDb9TgJOePMTXh ULJu5dFk0+oLfd0FSVBKqdX/+e9fHd+OIcHCgWbORocCIzMZ4scWNDJ5Awuh52VPjYx/mLKY+Zxu jqobK//1bTMvPe92QRIAYMuJVzc+/8ZzvyyKond9Y2Zk67l9s2GgUbAaD9h8xlf28785JHeYR8RU wp7asiUn092vnu/r7HZRJDAz/3D7D75zvHLsVIzIpAEHokaQFmYJzXdV50eWuV0f+vBeuFQ5zFdB UIQ+derchvKPv30x2IALG6Pbeod6uquiOnT71I/dLZUK6rmf2zOTX8QIvcCaIerNLIVEuAzPwT37 OtyukWc/E6EJK8v/+g+Hk1dWXnESAGB/596dcybeNP+GkTfNTk0HyoqsAIwP2MaHXOWzP4flnZ5h qoP7lxFUcM4Z4I0qBwBE1IzXqqtWrhz43tcvxgsuiQSllNrRtX3z4rfdcd+4wvixkmXGCG3klR2h sscULIdlAaXwJdK1P5QFmr+eIcJWJBTQI0+dfrrvbz9d4e5zbwbXmyIB0GlxrHq07aPT7vpEgYsF xTpRmXVpZNbNksqnhMpHUO8S+q/N8hHPg0Xu3JHCACCgwOmzfd/40vFk+4Y3i+lNkwAAR3raWtNC kn5o0qLF9qdvBKCdL4Ay/qAjRxkQvlnyRWJ46edIYYCJEFMJvx945LtbB5f+6FLwXBIJALDz3PZX x44cN3H+2FsXSiVzRmjMKmeSHFQVK+0sCZQB77DSMGQQUKQWvDq49MkVfd/7enauefHbJZOglFKv nFm/6rpx069/16h570pU2qBKBB2jU4WucVYZlgQL/GJUYPcCNWPX4IoXn+n95hdT1KqXiuWSSQAA KaV8pWP9quljZ8y+ccTcG1NOAw9gTwhQrwhT77NK8Glhrd0Tku0nC6IFuwZ/++JTPQ89UOPKwOXg uCwSAKCaVKvrz65ZMX7UhKnvHjl/nlQKyi6K5KpEvl/IpwPQQAmuIviUKYgW7Ky8uPzJ7ocerHK5 /3IxXDYJAFBLa7X1Z1avKDU3jbh59ML3Co5IBkR4JVAdEZLD6jDcLFLvBIGImrC+/4nHlvb845dq PFi+EuO/IiQAOjU2d2xY08lnz94y9r0faMHIUmp9wvwA4qbTqPeE85ZCABEVkXBS/XXv9x9e3vuD bwy3Xngp2xUjAdBmua9r17ad5S2vXD/6xrnTim+fJpXM/Gzm/sAKAQmZ/oBy0SfE1Iz2pPXgzzv/ /i+2lH/9+JUcM3CFSbDbyYETR1edW/4sIhY3tMy9pUQthcSUURtua5j11YFdvxCjCQpSre178tGf dT70hfbk9V2Nn3h521tCAqCX7bd0/u/qHQOvrBtfnDT1utI7ro9RQKpkZpJVnw6EiIoQiHFgaPPG xzu/9dXV/T9/5Erlf6PtIpYoLn+Loij60Pi7PvmZiV/+uzlNt36AZIzBpAqpFAZVFZIVmAkRikhZ oa26d9eK3p8+smlg+RLJae2tHt9VIcFusYgLC8fcdsddYx/40i3NH76zBWNbKqoCpQj9sm9ob2Xz 2tX9Tz+2s/zySwlXB6/WuK4qCe6hRDS9NGvOB0be86fTirPmHars2r6jsu6Fo9UDb0nOX2j7P1Tv qsrRgEvvAAAAAElFTkSuQmCC ",
          id: "image9343",
          x: "37.54845",
          y: "84.347511"
        })]
      })
    })]
  });
};
;// CONCATENATED MODULE: ./components/LogoSection/index.tsx






var LOGO_SECTION_HEIGHT = 100;
var LogoImage = function LogoImage(_ref) {
  var src = _ref.src,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'contain' : _ref$objectFit,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
    width: 200,
    height: 75,
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    m: {
      base: '0 auto',
      md: 5
    },
    children: [src && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: src,
      layout: "fill",
      objectFit: objectFit,
      alt: "Cut Into The Jamstack logo"
    }), children && children]
  });
};
var LogoSection = function LogoSection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HomeSection, {
    id: "section-technologies",
    shaded: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
      size: "lg",
      alignItems: "center",
      mb: 10,
      children: "Tech you'll use in the book:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
      columns: [1, 2, 3, 4],
      spacing: "20px",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/react-logo.png",
        width: 500,
        height: 234
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/chakra-ui@2x.png",
        width: 1996,
        height: 514
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/nextjs-logo.png",
        width: 800,
        height: 479
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/stripe-logo.svg.webp",
        width: 2560,
        height: 1220
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/prisma-logo.png",
        width: 568,
        height: 320
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        width: 229,
        height: 54,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NextAuthLogo, {
          width: "100%",
          height: "100%"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/react-hook-form-logo.png",
        width: 1112,
        height: 140
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImage, {
        src: "/vercel-logo.png",
        width: 640,
        height: 233
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./pages/index.tsx











function Home() {
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    router.prefetch('/toc');
    router.prefetch('/articles');
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LogoSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Summary, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Features, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Pricing, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(NewsletterSignup, {})]
  });
}
/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(36042);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [994,550,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);